import React, {Component} from 'react';
const { connect } = require('react-redux');

import {t} from 'l10n';

import ProfileLink from 'components/ProfileLink';
import Pagination from 'components/Pagination';
import Loading from 'components/Loading';

import {nt} from '../../l10n';

import {getFavourites} from 'reducers/main';

import 'sass/index-favourites.scss';

const FAVOURITES_COUNT = 15;

class FavouritesIndex extends Component {
    constructor(props) {
        super(props);

        this.state = {
            page: props.favourites.page
        }
    }

    componentDidMount() {
        let {dispatch, favourites} = this.props;
        let {page} = this.state;

        if (!favourites.list) {
            this.constructor.fetchData({dispatch, params: {page}});
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.page !== prevState.page) {
            let {dispatch} = this.props;

            this.constructor.fetchData({dispatch, params: {page: this.state.page}});
        }
    }

    static fetchData({dispatch, params}) {
        const {page} = params;

        const reducerParams = {
            page,
            limit: FAVOURITES_COUNT
        };

        return dispatch(getFavourites(reducerParams));
    }

    render() {
        let {favourites} = this.props,
            {list, totalCount, isLoading} = favourites;

        let {page} = this.state;

        if (!list) {
            return <Loading/>;
        }

        return (
            <div className="favourites-index">
                <div className="content">
                    <div className="info">
                        <div className="left">
                            <ul>
                                <li>{t('List of members who received the greater number of gift points.')}</li>
                                <li>{t('Each virtual gift received increases your gift rating and you can get into the charts.')}</li>
                                <li>{t('Gift points are valid for 60 days.')}</li>
                                <li>{t('The more gift points you have the better status you get in the favourites of BobTV.')}</li>
                            </ul>
                        </div>
                        <div className="right">
                            <ul>
                                <li>{t('With 100 gift points you get a blue star')}<span className="ic-star1"/>.</li>
                                <li>{t('From 200 gift points you get a red star')}&nbsp;<span className="ic-star2"/>&nbsp;{t('and if you have over 500 gift points you receive a golden star')}<span className="ic-star3"/>.</li>
                            </ul>
                        </div>
                    </div>
                    {isLoading && <Loading/>}
                    <div className="list ui-responsive-grid">
                        {list.map((favouriteUser, index) =>
                            <FavouriteUserListItem favouriteUser={favouriteUser} key={index}/>
                        )}
                    </div>
                    <div className="page-list">
                        <Pagination
                            itemsPerPage={FAVOURITES_COUNT}
                            totalCount={totalCount}
                            currentPage={page}
                            onClick={(page) => this.setState({page})}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default connect(
    (state) => ({
        favourites: state.main.favourites,
    }),
    null
)(FavouritesIndex);

class FavouriteUserListItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentGiftIndex: undefined
        };

        this.rotateGifts = this.rotateGifts.bind(this);
    }

    componentDidMount() {
        let {favouriteUser} = this.props;

        if (favouriteUser.virtualGifts && favouriteUser.virtualGifts.length) {
            this.setState({currentGiftIndex: 0});

            this.intervalId = setInterval(this.rotateGifts, 5000);
        }
    }

    componentWillUnmount() {
        if (this.intervalId) clearInterval(this.intervalId);
    }

    rotateGifts() {
        let {favouriteUser} = this.props;
        let {currentGiftIndex} = this.state;

        this.setState({
            currentGiftIndex: favouriteUser.virtualGifts[currentGiftIndex+1] ? currentGiftIndex+1 : 0
        });
    }

    render() {
        let {favouriteUser} = this.props;
        let {currentGiftIndex} = this.state;

        return (
            <div>
                <div className="block-favourite">
                    <ProfileLink user={favouriteUser} className="img">
                        <img src={favouriteUser.avatar_url} alt={favouriteUser.nick}/>
                    </ProfileLink>
                    <div className="text">
                        {typeof currentGiftIndex != 'undefined' &&
                        <ProfileLink user={favouriteUser} className="gift">
                            <img src={favouriteUser.virtualGifts[currentGiftIndex].thumbnail_url}/>
                        </ProfileLink>
                        }
                        <div className="author-name-favourites">
                            <ProfileLink user={favouriteUser}/>
                        </div>
                        <div className="gift-rank">
                            <div className={'icon-start ic-star' + favouriteUser.gift_rank}></div>
                            {nt('%1 Gift point', '%1 Gift points', favouriteUser.gift_points)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/index/FavouritesIndex.js